export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13189.5faba70a.jpg";